import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import { TEXT_SECONDARY } from "design-system/colors";

const radioSize = (defaultSize = 18) => ({ radioBubbleSize = defaultSize }) =>
  `${radioBubbleSize}px`;

const regularStyles = css`
  appearance: none;
  background: ${colors.pureWhite};
  border: 1px solid ${TEXT_SECONDARY};
  border-radius: 1em;
  box-sizing: border-box;
  display: inline-block;
  height: ${radioSize(18)};
  margin: 0;
  width: ${radioSize(18)};

  &:checked {
    background-image: radial-gradient(
      circle at center,
      ${colors.pureWhite},
      ${colors.pureWhite} 26%,
      ${colors.primary} 30%,
      ${colors.primary} 100%
    );
    border-color: ${colors.primary};
  }
`;

const blueDotStyles = css`
  align-items: center;
  appearance: none;
  border: 1px solid ${TEXT_SECONDARY};
  border-radius: 50%;
  display: flex;
  height: ${radioSize(20)};
  margin: 0 11px 0 0;
  width: ${radioSize(20)};

  :before {
    background: white;
    border-radius: 50%;
    content: "";
    height: 8px;
    margin: auto;
    transform: scale(0);
    transition: transform 150ms cubic-bezier(0.175, 0.885, 0.32, 1);
    width: 8px;
  }

  :checked:before {
    background: ${colors.primary};
    border-radius: 50%;
    content: "";
    height: 8px;
    margin: auto;
    transform: scale(1);
    transition: transform 150ms cubic-bezier(0.175, 0.885, 0.32, 1);
    width: 8px;
  }

  :focus {
    outline-color: ${colors.primary};
  }
`;

export const InputRadio = styled.input.attrs({
  type: "radio"
})`
  ${({ theme }) => (theme === "blueDot" ? blueDotStyles : regularStyles)}
`;
